document.addEventListener('DOMContentLoaded', () => {

    document.addEventListener('focusout', (event) => {
        const $quantityInput = event.target;

        if ($quantityInput.matches('[data-input]')) {

            if ($quantityInput.closest('express-option-list')) {
                return;
            }

            const validateQty = () => {
                const currentValue = parseInt($quantityInput.value, 10);
                const minQuantity = parseInt($quantityInput.dataset.variantMinQty || $quantityInput.dataset.productMinQty, 10);

                if (currentValue < minQuantity || isNaN(currentValue)) {
                    setTimeout(() => {
                        $quantityInput.value = minQuantity;
                        $quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
                        $quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }, 100);
                }
            };

            validateQty();
        }
    }, true);
});
